import initialState from './initialState'
import { Modifier, EditorState, SelectionState } from 'draft-js'

const editorState = (state = initialState.editorState, { type, data }) => {
    switch (type) {
        case 'UPDATE_EDITOR_STATE':
            return {
                ...state,
                data,
            }
        case 'BODGEY_TEXT_THING':
            const selectionStateNew2 = SelectionState.createEmpty(
                data,
            ).merge({
                anchorOffset: 0,
                focusOffset: 0,
            })
            const textWithEntity2 = Modifier.insertText(
                state.data.getCurrentContent(),
                selectionStateNew2,
                ' ',
            )
            return {
                ...state,
                data: EditorState.push(
                    state.data,
                    textWithEntity2,
                    'insert-characters',
                ),
            }
        case 'REMOVE_BODGEY_TEXT_THING':
            const selectionStateNew3 = SelectionState.createEmpty(
                data,
            ).merge({
                anchorOffset: 0,
                focusOffset: 1,
            })
            const textWithEntity3 = Modifier.removeRange(
                state.data.getCurrentContent(),
                selectionStateNew3,
                'forward',
            )
            return {
                ...state,
                data: EditorState.push(
                    state.data,
                    textWithEntity3,
                    'insert-characters',
                ),
            }
        case 'REPLACE_EDITOR_STATE':
            const selectionStateNew = SelectionState.createEmpty(
                data.blockKey,
            ).merge({
                anchorOffset: data.start,
                focusOffset: data.end,
            })
            const textWithEntity = Modifier.replaceText(
                state.data.getCurrentContent(),
                selectionStateNew,
                data.synonym,
            )
            return {
                ...state,
                data: EditorState.push(
                    state.data,
                    textWithEntity,
                    'insert-characters',
                ),
            }
        default:
            return state
    }
}

export default editorState
